<div layout-fill layout="column" layout-align="center none">
    <div layout="row" layout-align="center none">
        <mat-card class="loggedOutCard" fxFlex.gt-xs="60%" fxFlex.gt-md="35%" fxFlex.xl="25%">
            <mat-card-header class="justifyContentCenter">
                <mat-card-title class="forgotPasswordTitle">Forgot Password</mat-card-title>
            </mat-card-header>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit(submitBtn)">
                <mat-card-content>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Email</mat-label>
                            <mat-icon matPrefix>person</mat-icon>
                            <input matInput placeholder="Email" formControlName="username" required>
                        </mat-form-field>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button color="primary" class="loginBtn" type="submit" #submitBtn>Reset Password</button>
                    <a mat-button routerLink="/login" class="padding0 fontWeight400">Back to Login</a>
                </mat-card-actions>
            </form>
        </mat-card>
    </div>
</div>
